// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// export const environment = {
//   production: false,
//   apiKey: 'f6c8e7f1-d152-4c9e-b756-42adab0663ef',
//   googleMapsApiKey: 'AIzaSyCrc4fnmh-UMASDlYsfXKKovFmEaYAS52k',
//   baseURL: 'https://dev-dp.leetrans.com/api',
//   authBaseURL: 'https://dev-auth.leetrans.com',
//   sentry: {
//     dsn: 'https://9569ad668f5d8a4322c51dc7aada9819@o4509287961526272.ingest.us.sentry.io/4509515712495616',
//     environment: 'development',
//     tracesSampleRate: 0.1,
//     debug: true,
//   },
// };

export const environment = {
  production: false,
  apiKey: 'f6c8e7f1-d152-4c9e-b756-42adab0663ef',
  googleMapsApiKey: 'AIzaSyCrc4fnmh-UMASDlYsfXKKovFmEaYAS52k',
  baseURL: 'https://api-dp.leetrans.com/api',
  authBaseURL: 'https://auth.leetrans.com',
  sentry: {
    dsn: 'https://9569ad668f5d8a4322c51dc7aada9819@o4509287961526272.ingest.us.sentry.io/4509515712495616',
    environment: 'production',
    tracesSampleRate: 0.1,
    debug: true,
  },
};

// local
// dp:
// https://localhost:56011/api
// identity:
//https://localhost:44300
// int:
// https://localhost:53970/

// prod
// https://api-dp.leetrans.com/api
// https://auth.leetrans.com

// dev
// https://dev-dp.leetrans.com/api
// https://dev-auth.leetrans.com'

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
